import { useMemo } from "react";
import { Box, Chip, Typography } from "@mui/material";
import PropTypes from "prop-types";
import DataTable from "@accredo/fe-shared/components/DataTable.jsx";

const ENTITY_LABEL = {
  kunde: "Kunde",
  vertrag: "Vertrag",
  objekt: "Objekt",
  objektsparte: "Objektsparte",
  gesellschaft: "Gesellschaft",
  user: "Benutzer",
  bank_account: "Bankkonto",
  user_contract_assignments: "Benutzer-Vertragszuordnungen",
};

export default function ImportCustomerOverviewTable({
  data,
  isLoading,
  hasLoaded,
  selected_kunde_id,
  onRowClick,
}) {
  const columns = useMemo(
    () => [
      {
        accessorKey: "name",
        header: "Kunde",
      },
      {
        accessorKey: "id_ov",
        header: "ID",
        size: 120,
        Cell: ({ cell }) => (
          <Typography
            variant="body2"
            sx={{ fontFamily: "monospace", fontSize: "0.8rem" }}
          >
            {cell.getValue()}
          </Typography>
        ),
      },
      {
        accessorKey: "skipped_types",
        header: "Übersprungene Entitäten",
        enableSorting: false,
        enableColumnFilter: false,
        Cell: ({ cell }) => (
          <Box display="flex" gap={0.5} flexWrap="wrap">
            {(cell.getValue() ?? []).map((t) => (
              <Chip
                key={t}
                label={ENTITY_LABEL[t] ?? t}
                size="small"
                color="warning"
                variant="outlined"
              />
            ))}
          </Box>
        ),
      },
    ],
    []
  );

  return (
    <DataTable
      columns={columns}
      data={data}
      isLoading={isLoading}
      hasLoaded={hasLoaded}
      manualSorting={false}
      manualFiltering={false}
      enableGlobalFilter={true}
      enableColumnFilters={false}
      muiTableBodyRowProps={({ row }) => ({
        selected: selected_kunde_id === row.original.kunde_id,
        onClick: () => onRowClick(row.original),
        sx: { cursor: "pointer" },
      })}
    />
  );
}

ImportCustomerOverviewTable.propTypes = {
  data: PropTypes.array.isRequired,
  isLoading: PropTypes.bool,
  hasLoaded: PropTypes.bool,
  selected_kunde_id: PropTypes.number,
  onRowClick: PropTypes.func.isRequired,
};
